import { GETv2Quote } from '@/api/quotes';

export const getGlobalList = async ({ queryKey }: { queryKey: string[] }) => {
  const column = 'D_FORMAT';
  const type = queryKey[1];

  try {
    const res = await GETv2Quote({ column, type });

    return res;
  } catch (e) {
    console.error(e);
    return [];
  }
};
